import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { CustomCard, CardBody } from "../../../../components/CustomCard";
import profileIcon from "url:shared-assets/icons/profile.svg";
import CustomButton from "../../../../components/CustomButton";

const NoNextMeetingCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <CustomCard className="overflow-visible">
      <CardBody className="p-4 flex flex-col gap-4 overflow-visible">
        <div className="flex flex-col py-4 gap-2 justify-center align-middle items-center">
          <img src={profileIcon} alt="Calendar" className="w-8 h-8" />
          <p className="z-body1 text-white whitespace-pre-line text-center">
            {t("select-coach")}
          </p>
        </div>

        <CustomButton
          buttonType="blueBase"
          onClick={() => navigate("/videocoach/match-with-coach")}
        >
          {t("match-with-coach")}
        </CustomButton>
      </CardBody>
    </CustomCard>
  );
};

export default NoNextMeetingCard;
